/**
 * Decisiones puras del interceptor 401 de axios.
 *
 * El filtro JWT del backend responde 401 ANTES de ejecutar logica de negocio, pero
 * reenviar automaticamente un POST/PUT/DELETE tras un refresh es peligroso (puede
 * duplicar una transaccion si el 401 vino de un intermediario/timeout). Solo se
 * reenvian metodos idempotentes.
 */
const IDEMPOTENT_METHODS = ['get', 'head'];

export function shouldReplay(config, error) {
  if (!config || !error || !error.response || error.response.status !== 401) {
    return false;
  }
  if (config._retry) {
    return false;
  }
  if (typeof config.method !== 'string'
    || !IDEMPOTENT_METHODS.includes(config.method.toLowerCase())) {
    return false;
  }
  const url = typeof config.url === 'string' ? config.url : '';
  if (url === 'inicioSesion' || url.includes('/v1/refreshToken')) {
    return false;
  }
  return true;
}

/**
 * POST /v1/refreshToken responde { header, data: { token } }. Para un token vencido
 * responde HTTP 200 con data null. Devuelve el token o null; nunca un valor falsy
 * disfrazado (el string "undefined" tambien se rechaza).
 */
export function extractRefreshedToken(response) {
  const token = response && response.data && response.data.data
    ? response.data.data.token
    : undefined;
  if (typeof token !== 'string' || token === '' || token === 'undefined' || token === 'null') {
    return null;
  }
  return token;
}
